import { FunctionComponent } from "react";
import Label from "../../Label";
import "./styles.scss";
import { Icon } from "../../Icon";

type Props = {
  title: string;
  thumbnailUrl: string;
  variations: number;
};

const ProductCard: FunctionComponent<Props> = ({
  title,
  thumbnailUrl,
  variations,
}) => {
  const image = thumbnailUrl.includes("|")
    ? thumbnailUrl.split("|")[0]
    : thumbnailUrl;
  return (
    <div className="card">
      <div className="">
        {image ? (
          <img
            src={image}
            alt={title}
            className="card__img"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = "https://assets.rtabak.com.ar/rtabak.png";
            }}
          />
        ) : (
          <Icon iconName="rtabak_icon" className="card__img" />
        )}
      </div>
      <div className="card-body">
        <Label
          tag="p"
          variants="subtitle"
          style={{ color: "black", fontFamily: "Mont-Semibold" }}
        >
          {title}
        </Label>
        <Label tag="p" variants="body2" className="card__text">
          {`Cantidad: ${variations}`}
        </Label>
      </div>
    </div>
  );
};

export default ProductCard;
